export default __webpack_public_path__ + "static/media/familia_1.baa64035.jpg";